// L'ARC DU SAUT (05/08, retour Claude-Alain : « les moines sauteurs sautent de manière
// moche, on dirait qu'ils flottent dessus le trou »). La simulation fait GLISSER le sauteur
// en ligne droite (`hop` décompte 2×SUB sous-unités, x avance d'1 su/tick, chute suspendue) :
// exact et déterministe, mais plat à l'écran. Ici on calcule l'HABILLAGE du saut : une
// parabole verticale, une inclinaison vers l'avant et un étirement dans le sens du
// mouvement, tous dérivés de `hop` seul — le RENDU bouge, la simulation partagée ne change
// pas d'un bit (zéro risque de désynchronisation en ligne, même recette que l'arc peint
// par-dessus la glissade des rampes). L'ombre au sol, elle, ne saute PAS : c'est l'écart
// ombre/corps qui donne la hauteur, comme pour toute chute.
// Le crapaud (objet versus) réutilisera ce même arc : un seul saut dans tout le jeu.

export interface SautPose {
  t: number     // progression 0 (décollage) -> 1 (atterrissage)
  dy: number    // élévation en FRACTION de case (0 .. HAUTEUR) — le caller multiplie par TS
  lean: number  // inclinaison vers l'avant en radians (le flip du rendu suit déjà `face`)
  sy: number    // étirement vertical (le caller prend 1/sy en largeur pour garder le volume)
}

const HAUTEUR = 0.5    // apex à une demi-case : il SAUTE, il ne plane plus
const LEAN = 0.17      // ~10° vers l'avant à l'apex
const ETIRE = 0.22     // étiré au décollage et dans la descente, neutre à l'apex et posé

// `hop` décompte de `total` vers 0 ; au tick d'amorce le premier pas est déjà fait
// (prevHop = 0, curHop = total - 1) : on reconstruit ce départ pour que l'arc parte du sol.
// alpha = interpolation de rendu entre les deux états (la même que lerpPos).
export function poseDuSaut(prevHop: number, curHop: number, alpha: number, total: number): SautPose | null {
  if (curHop <= 0 && prevHop <= 0) return null
  const hPrev = prevHop > 0 ? prevHop : Math.min(total, curHop + 1)
  const h = hPrev * (1 - alpha) + curHop * alpha
  const t = Math.min(1, Math.max(0, 1 - h / total))
  const cloche = 4 * t * (1 - t)                      // 0 -> 1 (apex) -> 0
  return {
    t,
    dy: HAUTEUR * cloche,
    lean: LEAN * Math.sin(t * Math.PI),
    // |1-2t| = vitesse verticale (max aux deux bouts, nulle à l'apex) ; multipliée par la
    // cloche pour retomber à zéro pile au sol : aucun « pop » au décollage ni à l'arrivée.
    sy: 1 + ETIRE * Math.abs(1 - 2 * t) * cloche,
  }
}
